import {
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
  Route,
  Outlet,
} from 'react-router-dom';
import { StakePage } from 'src/pages/stake/Stake.page';
import { ClaimPage } from 'src/pages/claim/Claim.page';
import { PortfolioPage } from 'src/pages/portfolio/Portfolio.page';
import { DefiPage } from 'src/pages/defi/Defi.page';
import { FaucetPage } from 'src/pages/faucet/Faucet.page';
import { NotFoundPage } from 'src/pages/NotFound/NotFound.page';
import { Layout } from 'src/components/Layout/Layout';
import {
  SHOW_DEFI_PAGE,
  SHOW_PORTFOLIO_PAGE,
  SHOW_FAUCET,
} from 'src/constants';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      element={
        <Layout>
          <Outlet />
        </Layout>
      }
    >
      <Route path="/" element={<StakePage />} />
      {SHOW_DEFI_PAGE && <Route path="/ecosystem" element={<DefiPage />} />}
      <Route path="/withdrawals" element={<ClaimPage />} />
      {SHOW_PORTFOLIO_PAGE && (
        <Route path="/portfolio" element={<PortfolioPage />} />
      )}
      {SHOW_FAUCET && <Route path="/faucet" element={<FaucetPage />} />}
      <Route path="*" element={<NotFoundPage />} />
    </Route>
  )
);

export function Router() {
  return <RouterProvider router={router} />;
}
